// feature/apple-treatment — shared hover-focus state for a list. The parent list component
// wraps its rows; rows call setFocusedRowId(id) when they enter focus and
// setFocusedRowId(null) when they leave. The list reads `focusedRowId` to
// toggle the `has-focused-row` className on its container.
import React, { createContext, useContext, useState } from "react";

const Ctx = createContext({ focusedRowId: null, setFocusedRowId: () => {} });

export function HoverFocusProvider({ children }) {
  const [focusedRowId, setFocusedRowId] = useState(null);
  return (
    <Ctx.Provider value={{ focusedRowId, setFocusedRowId }}>
      {children}
    </Ctx.Provider>
  );
}

export function useHoverFocus() {
  return useContext(Ctx);
}
